/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import ApplicationSerializer from './application';

export default class UsageLimitSerializer extends ApplicationSerializer {
  attrs = {
    metric: 'metric_name', // Maps model attribute 'metric' to API field 'metric_name'
  };
}
